"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation generateOrderReport($query: OrderQueryInput) {
    generateOrderReport(query: $query) {
      url
      message
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=generateOrderReport.mutation.js.map